export default __webpack_public_path__ + "static/media/for-jobseekers.6f27d607.svg";